/* =========================================================
   KHUSHBU CART CRO  v2.4
   Minimog 4.0 compatible · no dependencies
   - shipping bar animation (fill + truck)
   - (i) tooltip
   - upsell slider (swipe, arrows, "1 of N")
   - Add to cart / bundle upgrade without page reload
   - header item count sync
   - v2.4: Bank Transfer (Scala) button shows live "SAVE Rs X EXTRA"
======================================================== */
(function () {
  if (window.__khCartCroV2) return;
  window.__khCartCroV2 = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var lastPct = null;

  /* ---------------- helpers ---------------- */
  function postJSON(url, body) {
    return fetch(ROOT + url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || "Something went wrong");
        return data;
      });
    });
  }

  function refreshCart() {
    var drawer = document.querySelector("m-cart-drawer");
    if (drawer && typeof drawer.onCartDrawerUpdate === "function") {
      drawer.onCartDrawerUpdate(true); // re-renders items, bar, upsell, totals (keeps app buttons in footer)
    }
    return fetch(ROOT + "cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(".m-cart-count-bubble").forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle("m:hidden", cart.item_count === 0);
          el.classList.toggle("hidden", cart.item_count === 0);
        });
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          window.MinimogEvents.emit(
            window.MinimogTheme.pubSubEvents.cartUpdate,
            Object.assign({}, cart, { source: "khushbu-cart-cro" })
          );
        }
        return cart;
      })
      .catch(function (e) { console.warn("[Khushbu cart]", e); });
  }

  function busy(btn, label) {
    btn.dataset.label = btn.dataset.label || btn.textContent.trim();
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    btn.textContent = label;
  }

  function done(btn, ok, msg) {
    btn.removeAttribute("aria-busy");
    btn.classList.add(ok ? "is-done" : "is-error");
    btn.textContent = ok ? "✓ Added" : "Try again";
    if (!ok && msg) btn.title = msg;
    setTimeout(function () {
      if (!btn.isConnected) return;
      btn.disabled = false;
      btn.classList.remove("is-done", "is-error");
      btn.textContent = btn.dataset.label || "Add";
    }, ok ? 1200 : 2200);
  }

  /* ---------------- shipping bar ---------------- */
  function animateBars() {
    document.querySelectorAll(".kh-ship__fill:not([data-kh-init])").forEach(function (fill) {
      fill.setAttribute("data-kh-init", "1");
      var target = parseFloat(fill.getAttribute("data-kh-pct")) || 0;
      var wrap = fill.closest(".kh-ship__track-wrap");
      var truck = wrap && wrap.querySelector("[data-kh-truck]");
      if (reduceMotion || lastPct === null || lastPct === target) { lastPct = target; return; }

      fill.style.transition = "none";
      fill.style.width = lastPct + "%";
      if (truck) { truck.style.transition = "none"; truck.style.left = lastPct + "%"; }
      void fill.offsetWidth;
      fill.style.transition = "";
      if (truck) truck.style.transition = "";
      requestAnimationFrame(function () {
        fill.style.width = target + "%";
        if (truck) truck.style.left = target + "%";
      });
      lastPct = target;
    });
  }

  /* ---------------- header count ---------------- */
  function syncHeaderCount() {
    var src = document.querySelector("m-cart-drawer .kh-totals[data-kh-count]");
    var head = document.querySelector("[data-kh-head-count]");
    if (!src || !head) return;
    var n = parseInt(src.getAttribute("data-kh-count"), 10) || 0;
    head.textContent = "(" + n + ")";
    head.classList.toggle("kh-hide", n === 0);
  }

  /* ---------------- upsell slider ---------------- */
  function sliderState(root) {
    var track = root.querySelector("[data-kh-track]");
    if (!track) return;
    var slides = track.children.length;
    var w = track.clientWidth || 1;
    var idx = Math.round(track.scrollLeft / w);
    if (idx > slides - 1) idx = slides - 1;
    var cur = root.querySelector("[data-kh-current]");
    var prev = root.querySelector("[data-kh-prev]");
    var next = root.querySelector("[data-kh-next]");
    if (cur) cur.textContent = idx + 1;
    if (prev) prev.disabled = idx <= 0;
    if (next) next.disabled = idx >= slides - 1;
  }

  function initSliders() {
    document.querySelectorAll("[data-kh-up]:not([data-kh-init])").forEach(function (root) {
      root.setAttribute("data-kh-init", "1");
      var track = root.querySelector("[data-kh-track]");
      if (!track) return;
      var t;
      track.addEventListener("scroll", function () {
        clearTimeout(t);
        t = setTimeout(function () { sliderState(root); }, 60);
      }, { passive: true });
      track.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") { e.preventDefault(); go(root, 1); }
        if (e.key === "ArrowLeft") { e.preventDefault(); go(root, -1); }
      });
      sliderState(root);
    });
  }

  function go(root, dir) {
    var track = root.querySelector("[data-kh-track]");
    if (!track) return;
    track.scrollBy({ left: dir * track.clientWidth, behavior: reduceMotion ? "auto" : "smooth" });
  }

  /* ---------------- run on load + every drawer re-render ---------------- */
  function initAll() {
    animateBars();
    initSliders();
    syncHeaderCount();
    paintScala();
  }


  /* ---------------- v2.4 Bank Transfer button (Scala app, open shadow DOM) ----------------
     Scala keeps full control of the click (discount + checkout). We only paint two text lines:
       line 1: "SAVE Rs X EXTRA"  (X = bank % of cart total, from Liquid → .kh-totals[data-kh-bank-l1])
       line 2: "BANK TRANSFER"
     The amount refreshes after every cart change because Minimog re-renders .kh-totals.
     If a discount code (e.g. WELCOME5) is applied, the bank % does not combine → no amount shown. */
  var SCALA_CSS =
    ".kh-l1,.kh-l2{display:block;font:inherit;color:inherit;text-transform:uppercase;line-height:0.5;pointer-events:none}" +
    ".kh-l1{font-weight:800;letter-spacing:.03em;text-transform:none}" +
    ".kh-l2{margin-top:3px;font-size:.82em;font-weight:600;letter-spacing:.09em;opacity:.85}";
  var scalaPauseUntil = 0;
  var scalaRaf = 0;

  function bankLabels() {
    var t = document.querySelector("m-cart-drawer .kh-totals");
    var l1 = t ? (t.getAttribute("data-kh-bank-l1") || "").trim() : "";
    if (l1) return { l1: l1, l2: "Bank Transfer" };
    return { l1: "BANK TRANSFER", l2: "Pay direct to bank" };
  }

  function paintScala() {
    var hosts = document.querySelectorAll("#MinimogCartDrawerFooter scala-cart-button");
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var root = host.shadowRoot;
      if (!root) continue; /* closed/unavailable → Scala keeps its own text, colours still applied via ::part */
      if (!root.__khObs && "MutationObserver" in window) {
        root.__khObs = new MutationObserver(queuePaint); /* Scala re-render → paint again */
        root.__khObs.observe(root, { childList: true, subtree: true, characterData: true });
      }
      var btn = root.querySelector('[part~="actualbutton"]') || root.querySelector("button");
      if (!btn) continue;
      if (!root.querySelector("style[data-kh]")) {
        var st = document.createElement("style");
        st.setAttribute("data-kh", "");
        st.textContent = SCALA_CSS;
        root.appendChild(st);
      }
      if (Date.now() < scalaPauseUntil) continue; /* Scala is busy after a click – don't touch its loading state */
      var L = bankLabels();
      var key = L.l1 + "|" + L.l2;
      if (btn.getAttribute("data-kh-key") === key && btn.querySelector(".kh-l1")) continue; /* nothing changed */
      btn.setAttribute("data-kh-key", key);
      var a = document.createElement("span"); a.className = "kh-l1"; a.textContent = L.l1;
      var b = document.createElement("span"); b.className = "kh-l2"; b.textContent = L.l2;
      btn.textContent = "";
      btn.appendChild(a);
      btn.appendChild(b);
      btn.setAttribute("aria-label", L.l1 + ", " + L.l2);
    }
  }
  function queuePaint() {
    if (scalaRaf) return;
    scalaRaf = requestAnimationFrame(function () { scalaRaf = 0; paintScala(); });
  }
  /* Scala loads async → retry a few times after page load */
  [300, 1000, 2500, 5000].forEach(function (ms) { setTimeout(queuePaint, ms); });
  /* after the customer clicks the bank button, leave Scala's own loading state alone for a moment */
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest || !e.target.closest("scala-cart-button")) return;
    scalaPauseUntil = Date.now() + 6000;
    setTimeout(queuePaint, 6100);
  }, true);

  if ("MutationObserver" in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; initAll(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();

  window.addEventListener("resize", function () {
    document.querySelectorAll("[data-kh-up]").forEach(sliderState);
  });

  /* ---------------- clicks ---------------- */
  document.addEventListener("click", function (e) {
    /* tooltip */
    var tipBtn = e.target.closest("[data-kh-tip-btn]");
    document.querySelectorAll(".kh-tip.is-open").forEach(function (tip) {
      if (!tipBtn || tip !== tipBtn.closest(".kh-tip")) {
        tip.classList.remove("is-open");
        var b = tip.querySelector("[data-kh-tip-btn]");
        if (b) b.setAttribute("aria-expanded", "false");
      }
    });
    if (tipBtn) {
      e.preventDefault();
      e.stopPropagation();
      var tip = tipBtn.closest(".kh-tip");
      var open = tip.classList.toggle("is-open");
      tipBtn.setAttribute("aria-expanded", open ? "true" : "false");
      return;
    }

    /* slider arrows */
    var arrow = e.target.closest("[data-kh-prev], [data-kh-next]");
    if (arrow && !arrow.disabled) {
      e.preventDefault();
      go(arrow.closest("[data-kh-up]"), arrow.hasAttribute("data-kh-next") ? 1 : -1);
      return;
    }

    /* add upsell */
    var add = e.target.closest("[data-kh-add]");
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      busy(add, "Adding…");
      postJSON("cart/add.js", { items: [{ id: Number(add.getAttribute("data-kh-add")), quantity: 1 }] })
        .then(function () { done(add, true); return refreshCart(); })
        .catch(function (err) { done(add, false, err.message); });
      return;
    }

    /* bundle upgrade: swap single perfume → bundle */
    var up = e.target.closest("[data-kh-upgrade]");
    if (up) {
      e.preventDefault();
      if (up.disabled) return;
      var updates = {};
      var lineV = up.getAttribute("data-kh-line-variant");
      var lineQ = parseInt(up.getAttribute("data-kh-line-qty"), 10) || 1;
      updates[lineV] = Math.max(lineQ - 1, 0);
      updates[up.getAttribute("data-kh-upgrade")] = 1;
      busy(up, "Upgrading…");
      postJSON("cart/update.js", { updates: updates })
        .then(function () { done(up, true); return refreshCart(); })
        .catch(function (err) { done(up, false, err.message); });
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".kh-tip.is-open").forEach(function (tip) {
      tip.classList.remove("is-open");
      var b = tip.querySelector("[data-kh-tip-btn]");
      if (b) { b.setAttribute("aria-expanded", "false"); b.focus(); }
    });
  });

  /* ---------------- v2.2 "more offers below" cue (v2.4: every screen size) ---------------- */
  var mqCompact = window.matchMedia("(max-width: 767px), (max-height: 820px)");
  var cueRaf = 0;

  function cueParts() {
    var drawer = document.querySelector("m-cart-drawer");
    if (!drawer) return null;
    var cue = drawer.querySelector("[data-kh-more]");
    var body = drawer.querySelector(".m-cart-drawer__body");
    if (!cue || !body) return null;
    /* first offer the customer cannot see yet: bundle card, then the upsell product card */
    var b = body.getBoundingClientRect();
    var list = [
      { el: body.querySelector(".kh-bundle"), probe: body.querySelector(".kh-bundle"), label: "Bundle offer & more below" },
      { el: body.querySelector(".kh-up"), probe: body.querySelector(".kh-up__track") || body.querySelector(".kh-up"), label: "More picks for you below" }
    ];
    var target = null, label = "";
    for (var i = 0; i < list.length; i++) {
      if (!list[i].el || !list[i].probe) continue;
      if (list[i].probe.getBoundingClientRect().top > b.bottom - 48) { target = list[i].el; label = list[i].label; break; }
    }
    return { drawer: drawer, cue: cue, body: body, target: target, label: label };
  }

  function updateCue() {
    cueRaf = 0;
    var p = cueParts();
    if (!p) return;
    var show = false;
    if (p.target && p.drawer.classList.contains("m-cart-drawer--active")) { /* v2.4: all screen sizes */
      show = p.body.getBoundingClientRect().height > 0; /* an offer is below what the customer can see */
    }
    if (show) {
      var txt = p.cue.querySelector("[data-kh-more-text]");
      if (txt && txt.textContent !== p.label) txt.textContent = p.label; /* only touch DOM when it changes (no observer loop) */
    }
    if (p.cue.hidden === show) p.cue.hidden = !show;
  }
  function queueCue() { if (!cueRaf) cueRaf = requestAnimationFrame(updateCue); }

  document.addEventListener("scroll", function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains("m-cart-drawer__body")) queueCue();
  }, true);
  window.addEventListener("resize", queueCue);
  if (mqCompact.addEventListener) mqCompact.addEventListener("change", queueCue);

  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-kh-more-btn]")) return;
    e.preventDefault();
    var p = cueParts();
    if (!p || !p.target) return;
    var b = p.body.getBoundingClientRect(), r = p.target.getBoundingClientRect();
    p.body.scrollTo({ top: p.body.scrollTop + (r.top - b.top) - 12, behavior: reduceMotion ? "auto" : "smooth" });
    p.cue.hidden = true;
  });

  /* re-check when the drawer opens/closes and after every re-render */
  (function () {
    var drawer = document.querySelector("m-cart-drawer");
    if (!drawer || !("MutationObserver" in window)) return;
    new MutationObserver(function () { queueCue(); setTimeout(queueCue, 350); })
      .observe(drawer, { attributes: true, attributeFilter: ["class"], childList: true, subtree: true });
  })();
  queueCue();

})();
